import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ContactBookSvg = function ContactBookSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.33 5.704H9.523v5.185h8.807zm-7.34 3.703V7.185h5.872v2.222z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.018 2H22v20H4.018v-3.704H2v-1.481h2.018V12.74H2v-1.482h2.018V7.185H2V5.704h2.018zm1.468 18.519v-2.223h2.019v-1.481H5.486V12.74h2.019v-1.482H5.486V7.185h2.019V5.704H5.486V3.48h15.046v17.037z",
    clipRule: "evenodd"
  }));
};
export var ContactBook = function ContactBook(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ContactBookSvg
  }));
};